'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _components = require('components');

var _GenericSettings = require('redux/modules/GenericSettings');

var _EmailSettings = require('./EmailSettings.scss');

var _EmailSettings2 = _interopRequireDefault(_EmailSettings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmailSettings = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(EmailSettings, _Component);

  function EmailSettings() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, EmailSettings);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EmailSettings.__proto__ || (0, _getPrototypeOf2.default)(EmailSettings)).call.apply(_ref, [this].concat(args))), _this), _this._onInputChange = function (event) {
      if (_this.props.changeEmailSettingsProperty) {
        _this.props.changeEmailSettingsProperty(event.target.name, event.target.value);
      }
    }, _this._onRadioButtonChange = function (event) {
      var USE_OUTLOOK = 'Outlook';
      // TODO change to switch
      if (_this.props.changeEmailSettingsProperty) {
        if (event.target.id !== USE_OUTLOOK) {
          _this.props.changeEmailSettingsProperty(event.target.name, !event.target.checked);
        } else {
          _this.props.changeEmailSettingsProperty(event.target.name, event.target.checked);
        }
      }
    }, _this._onCheckBoxChange = function (event) {
      if (_this.props.changeEmailSettingsProperty) {
        _this.props.changeEmailSettingsProperty(event.target.name, event.target.checked);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  // TODO: _onCheckBoxChange review if this method is necessary


  (0, _createClass3.default)(EmailSettings, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          emailSettings = _props.emailSettings,
          smtpSet = _props.smtpSet;


      if (!emailSettings) return null;

      return _react2.default.createElement(
        _components.EnterpriseGrid.Row,
        { className: (0, _classnames2.default)(className, _EmailSettings2.default.root) },
        _react2.default.createElement(
          _components.EnterpriseGrid.Col,
          { xs: 12 },
          _react2.default.createElement(
            'div',
            { className: _EmailSettings2.default.header },
            _react2.default.createElement(
              'span',
              { className: _EmailSettings2.default.headerText },
              'EMAIL SETTINGS'
            )
          )
        ),
        _react2.default.createElement(
          _components.EnterpriseGrid.Col,
          { xs: 12 },
          _react2.default.createElement(
            _components.EnterpriseGrid.Row,
            null,
            _react2.default.createElement(
              _components.EnterpriseGrid.Col,
              { xs: 12 },
              _react2.default.createElement(
                'div',
                { className: _EmailSettings2.default.emailProviderField },
                _react2.default.createElement(
                  'label',
                  { htmlFor: 'EmailProvider' },
                  'EMAIL PROVIDER'
                ),
                _react2.default.createElement('div', { className: _EmailSettings2.default.spacer }),
                _react2.default.createElement(_components.EnterpriseRadioButton, {
                  className: _EmailSettings2.default.radioButton,
                  label: 'SMTP',
                  id: 'SMTP',
                  name: 'useOutlook',
                  onChange: this._onRadioButtonChange,
                  checked: !emailSettings.useOutlook || false
                }),
                _react2.default.createElement('div', { className: _EmailSettings2.default.spacer }),
                _react2.default.createElement(_components.EnterpriseRadioButton, {
                  className: _EmailSettings2.default.radioButton,
                  label: 'MICROSOFT OUTLOOK',
                  id: 'Outlook',
                  name: 'useOutlook',
                  onChange: this._onRadioButtonChange,
                  checked: emailSettings.useOutlook || false
                })
              )
            ),
            smtpSet && _react2.default.createElement(
              _components.EnterpriseGrid.Col,
              { xs: 12, md: 12, lg: 12 },
              _react2.default.createElement(
                'div',
                { className: _EmailSettings2.default.emailProviderField },
                _react2.default.createElement(
                  'label',
                  { htmlFor: 'fromEmail' },
                  'EMAIL ADDRESS'
                ),
                _react2.default.createElement(_components.EnterpriseInput, {
                  id: 'fromEmail',
                  name: 'fromEmail',
                  placeholder: 'Sender',
                  type: 'text',
                  size: _components.ENTERPRISE_INPUT_SIZES.MEDIUM,
                  fill: true,
                  onChange: this._onInputChange,
                  value: emailSettings.fromEmail || ''
                })
              )
            ),
            smtpSet && _react2.default.createElement(
              _components.EnterpriseGrid.Col,
              { xs: 12, md: 12, lg: 12 },
              _react2.default.createElement(
                'div',
                { className: _EmailSettings2.default.emailProviderField },
                _react2.default.createElement(
                  'label',
                  { htmlFor: 'userName' },
                  'USERNAME'
                ),
                _react2.default.createElement(_components.EnterpriseInput, {
                  id: 'userName',
                  name: 'userName',
                  placeholder: 'Username',
                  type: 'text',
                  size: _components.ENTERPRISE_INPUT_SIZES.MEDIUM,
                  fill: true,
                  onChange: this._onInputChange,
                  value: emailSettings.userName || ''
                })
              )
            ),
            smtpSet && _react2.default.createElement(
              _components.EnterpriseGrid.Col,
              { xs: 12, md: 12, lg: 12 },
              _react2.default.createElement(
                'div',
                { className: _EmailSettings2.default.emailProviderField },
                _react2.default.createElement(
                  'label',
                  { htmlFor: 'password' },
                  'PASSWORD'
                ),
                _react2.default.createElement(_components.EnterpriseInput, {
                  id: 'password',
                  name: 'password',
                  placeholder: 'password',
                  type: 'password',
                  size: _components.ENTERPRISE_INPUT_SIZES.MEDIUM,
                  fill: true,
                  onChange: this._onInputChange,
                  value: emailSettings.password || ''
                })
              )
            ),
            smtpSet && _react2.default.createElement(
              _components.EnterpriseGrid.Col,
              { xs: 12, md: 12, lg: 12 },
              _react2.default.createElement(
                'div',
                { className: _EmailSettings2.default.emailProviderField },
                _react2.default.createElement(
                  'label',
                  { htmlFor: 'host' },
                  'SMTP SERVER'
                ),
                _react2.default.createElement(_components.EnterpriseInput, {
                  id: 'host',
                  name: 'host',
                  placeholder: 'SMTP Server',
                  type: 'text',
                  size: _components.ENTERPRISE_INPUT_SIZES.MEDIUM,
                  fill: true,
                  onChange: this._onInputChange,
                  value: emailSettings.host || ''
                })
              )
            ),
            smtpSet && _react2.default.createElement(
              _components.EnterpriseGrid.Col,
              { xs: 12, md: 12, lg: 12 },
              _react2.default.createElement(
                'div',
                { className: _EmailSettings2.default.emailProviderField },
                _react2.default.createElement(
                  'label',
                  { htmlFor: 'smtpPort' },
                  'PORT'
                ),
                _react2.default.createElement(_components.EnterpriseInput, {
                  id: 'smtpPort',
                  name: 'smtpPort',
                  placeholder: 'Port',
                  type: 'text',
                  size: _components.ENTERPRISE_INPUT_SIZES.MEDIUM,
                  fill: true,
                  onChange: this._onInputChange,
                  value: emailSettings.smtpPort || ''
                })
              )
            ),
            smtpSet && _react2.default.createElement(
              _components.EnterpriseGrid.Col,
              { xs: 12, md: 12, lg: 12 },
              _react2.default.createElement(
                'div',
                { className: _EmailSettings2.default.emailProviderField },
                _react2.default.createElement(_components.EnterpriseCheckBox, {
                  className: _EmailSettings2.default.ssl,
                  id: 'smtpEnableSsl',
                  name: 'smtpEnableSsl',
                  label: 'SSL',
                  onChange: this._onCheckBoxChange,
                  checked: emailSettings.smtpEnableSsl || false
                })
              )
            )
          ),
          _react2.default.createElement(
            _components.EnterpriseGrid.Row,
            { className: _EmailSettings2.default.body },
            _react2.default.createElement(
              _components.EnterpriseGrid.Col,
              { xs: 12 },
              _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)(_EmailSettings2.default.copyTo, _EmailSettings2.default.inputGroup) },
                _react2.default.createElement(
                  'label',
                  { htmlFor: emailSettings.alwaysSendACopyTo },
                  'ALWAYS SEND COPY TO'
                ),
                _react2.default.createElement(_components.EnterpriseInput, {
                  id: 'alwaysSendACopyTo',
                  name: 'alwaysSendACopyTo',
                  placeholder: 'Send copy to',
                  type: 'text',
                  size: _components.ENTERPRISE_INPUT_SIZES.DEFAULT,
                  fill: true,
                  value: emailSettings.alwaysSendACopyTo || '',
                  onChange: this._onInputChange
                })
              )
            )
          )
        )
      );
    }
  }]);
  return EmailSettings;
}(_react.Component), _class.preload = function () {
  return [[_GenericSettings.fetchGenericSettingsSaga, _GenericSettings.getGenericSettings.base()]];
}, _class.propTypes = {
  emailSettings: _react.PropTypes.object,
  changeEmailSettingsProperty: _react.PropTypes.func,
  getGenericSettings: _react.PropTypes.func,
  className: _react.PropTypes.string
}, _class.defaultProps = {
  emailSettings: {}
}, _temp2);


var mapStateToProps = function mapStateToProps(state) {
  return {
    emailSettings: state.genericSettings.emailSettings,
    smtpSet: !state.genericSettings.emailSettings.useOutlook
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  getGenericSettings: _GenericSettings.getGenericSettings.base,
  changeEmailSettingsProperty: _GenericSettings.changeEmailSettingsProperty
})(EmailSettings);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/EmailSettings/EmailSettings.jsx
// module id = 1454
// module chunks = 0